(()=>{
const audList = [
  {
    "countryLabel": "United States",
    "stateLabel": "AK",
    "stateEntries": [
      {
        "name": "Hearalaska.com",
        "address": "4200 Lake Otis Pkwy Suite 302",
        "city": "Anchorage",
        "state": "AK",
        "postalCode": "99508",
        "country": "United States",
        "phone": "(907) 563-8008"
      },
      {
        "name": "Anchorage Audiology Clinic",
        "address": "3730 Rhone Cir #104",
        "city": "Anchorage",
        "state": "AK",
        "postalCode": "99508",
        "country": "United States",
        "phone": "(907) 563-8008"
      },
      {
        "name": "The Hearing Center",
        "address": "9095 Glacier Hwy",
        "city": "Juneau",
        "state": "AK",
        "postalCode": "99801",
        "country": "United States",
        "phone": "(907) 789-2359"
      },
      {
        "name": "Northland Hearing Services",
        "address": "29 College Rd Ste. 6",
        "city": "Fairbanks",
        "state": "AK",
        "postalCode": "99701",
        "country": "United States",
        "phone": "(907) 451-4327"
      },
      {
        "name": "Anchorage Audiology Clinic",
        "address": "3730 Rhone Cir",
        "city": "Anchorage",
        "state": "AK",
        "postalCode": "99508",
        "country": "United States",
        "phone": "(907) 563-8008"
      },
      {
        "name": "Northern Audiology & Hearing Aid Center",
        "address": "1919 Lathrop St",
        "city": "Fairbanks",
        "state": "AK",
        "postalCode": "99701",
        "country": "United States",
        "phone": "(907) 456-7768"
      }
    ]
  },
  {
    "countryLabel": "",
    "stateLabel": "AL",
    "stateEntries": [
      {
        "name": "Northeast Alabama Audiology Clinic",
        "address": "417 S 4th St.",
        "city": "Gadsden",
        "state": "AL",
        "postalCode": "35901",
        "country": "United States",
        "phone": "(256) 543-8899"
      },
      {
        "name": "AUM Speech and Hearing Clinic",
        "address": "7041 Senators Dr.",
        "city": "Montgomery",
        "state": "AL",
        "postalCode": "36117",
        "country": "United States",
        "phone": "(334) 244-3408"
      },
      {
        "name": "Modern Hearing Aid Center",
        "address": "1900 11th Ave.",
        "city": "S. Birmingham",
        "state": "AL",
        "postalCode": "35205",
        "country": "United States",
        "phone": "(205) 322-4272"
      },
      {
        "name": "Hearing and Speech Clinic",
        "address": "303 Williams Ave SW",
        "city": "Huntsville",
        "state": "AL",
        "postalCode": "35801",
        "country": "United States",
        "phone": "(256) 536-7405"
      },
      {
        "name": "Center For Hearing",
        "address": "7531 Memorial Pkwy SW",
        "city": "Huntsville",
        "state": "AL",
        "postalCode": "35802",
        "country": "United States",
        "phone": "(256) 489-7700"
      }
    ]
  },
  {
    "countryLabel": "",
    "stateLabel": "AR",
    "stateEntries": [
      {
        "name": "A Plus Hearing Service",
        "address": "500 S University Ave.",
        "city": "Little Rock",
        "state": "AR",
        "postalCode": "72205",
        "country": "United States",
        "phone": "(501) 664-0337"
      },
      {
        "name": "Pinnacle Hearing",
        "address": "10700 N Rodney Parham Rd #7",
        "city": "Little Rock",
        "state": "AR",
        "postalCode": "72212",
        "country": "United States",
        "phone": "(501) 225-6060"
      },
      {
        "name": "Center For Hearing",
        "address": "4300 Rogers Ave #15",
        "city": "Fort Smith",
        "state": "AR",
        "postalCode": "72903",
        "country": "United States",
        "phone": "(479) 689-4307"
      },
      {
        "name": "Physician Hearing Services",
        "address": "2100 N Green Acres RD",
        "city": "Fayetteville",
        "state": "AR",
        "postalCode": "72703",
        "country": "United States",
        "phone": "(479) 587-0088"
      },
      {
        "name": "Beltone Hearing Aid Center",
        "address": "1100 Lexington Ave",
        "city": "Fort Smith",
        "state": "AR",
        "postalCode": "72901",
        "country": "United States",
        "phone": "(479) 782-5858"
      },
      {
        "name": "North Little Rock",
        "address": "4844 N Hills Blvd",
        "city": "North Little Rock",
        "state": "AR",
        "postalCode": "72116",
        "country": "United States",
        "phone": "(501) 771-9300"
      },
      {
        "name": "Better Hearing Care",
        "address": "2835 College Ave",
        "city": "Conway",
        "state": "AR",
        "postalCode": "72034",
        "country": "United States",
        "phone": "(501) 329-7979"
      }
    ]
  },
  {
    "countryLabel": "",
    "stateLabel": "AZ",
    "stateEntries": [
      {
        "name": "Desert Sound Audiology",
        "address": "6124 E Brown Rd.",
        "city": "Mesa",
        "state": "AZ",
        "postalCode": "85205",
        "country": "United States",
        "phone": "(480) 497-3285"
      },
      {
        "name": "Southwest Hearing Center",
        "address": "7331 East Osborn Drive Suite 245",
        "city": "Scottsdale",
        "state": "AZ",
        "postalCode": "85251",
        "country": "United States",
        "phone": "(480) 949-1541"
      },
      {
        "name": "Southwest Hearing Center",
        "address": "3104 East Indian School Road Suite 120",
        "city": "Phoenix",
        "state": "AZ",
        "postalCode": "85016",
        "country": "United States",
        "phone": "(602) 224-5970"
      },
      {
        "name": "Adobe Hearing Center, Inc.",
        "address": "2102 N Country Club Rd, Ste. 12",
        "city": "Tucson",
        "state": "AZ",
        "postalCode": "85716",
        "country": "United States",
        "phone": "(520) 322-8211"
      },
      {
        "name": "Mark Heiser",
        "address": "1930 Mesquite Ave STE 5",
        "city": "Lake Havasu",
        "state": "AZ",
        "postalCode": "86403",
        "country": "United States",
        "phone": "(928) 855-5252"
      }
    ]
  },
  {
    "countryLabel": "",
    "stateLabel": "CA",
    "stateEntries": [
      {
        "name": "Love Hearing Services",
        "address": "11 west Delmar Blvd. ",
        "city": "Pasadena",
        "state": "CA",
        "postalCode": "91101",
        "country": "United States",
        "phone": "(626) 796-4535"
      },
      {
        "name": "Frances Miranda",
        "address": "11870 Santa Monica Boulevard, Suite 106",
        "city": "Los Angeles",
        "state": "CA",
        "postalCode": "90025",
        "country": "United States",
        "phone": "(310) 237-1031"
      },
      {
        "name": "American River Hearing",
        "address": "555 University Avenue, Suite 154",
        "city": "Sacramento",
        "state": "CA",
        "postalCode": "95825",
        "country": "United States",
        "phone": "(916) 927-9640"
      },
      {
        "name": "San Diego Hearing Center",
        "address": "4060 4th Ave #410A",
        "city": "San Diego",
        "state": "CA",
        "postalCode": "92103",
        "country": "United States",
        "phone": "(619) 298-8546"
      },
      {
        "name": "San Diego Hearing Center",
        "address": "4282 Genesee Ave",
        "city": "San Diego",
        "state": "CA",
        "postalCode": "92117",
        "country": "United States",
        "phone": "(858) 279-3277"
      },
      {
        "name": "Tustin Hearing Center",
        "address": "12791 Newport Ave #101",
        "city": "Tustin",
        "state": "CA",
        "postalCode": "92780",
        "country": "United States",
        "phone": "(714) 731-6549"
      },
      {
        "name": "California Hearing Center",
        "address": "88 N San Mateo Dr. ",
        "city": "San Mateo",
        "state": "CA ",
        "postalCode": "94401",
        "country": "United States",
        "phone": "(650) 342-9449"
      },
      {
        "name": "Rancho Santa Fe Audiology",
        "address": "6037 La Granada, Suite D ",
        "city": "Rancho Santa Fe",
        "state": "CA",
        "postalCode": "92067",
        "country": "United States",
        "phone": "(858) 759-8922 "
      },
      {
        "name": "La Ca\u00f1ada Hearing Aids & Audiology",
        "address": "1434 Foothill Boulevard, Suite C",
        "city": "La Ca\u00f1ada",
        "state": "CA",
        "postalCode": "91011",
        "country": "United States",
        "phone": "(818) 928 1400"
      },
      {
        "name": "California Hearing Aid Professionals",
        "address": "130 West Route 66, Suite 210",
        "city": "Glendora",
        "state": "CA",
        "postalCode": "91740",
        "country": "United States",
        "phone": "(626) 963-7200"
      },
      {
        "name": "Sharzad Cohen, Au.D. FAAA",
        "address": "5900 Sepulveda Blvd. Suite 335.",
        "city": "Sherman Oaks",
        "state": "CA",
        "postalCode": "91411",
        "country": "United States",
        "phone": "(818) 989-9001"
      },
      {
        "name": "Sherman Oaks Ear and Hearing Institute ",
        "address": "4910 Van Nuys Blvd  Ste 201",
        "city": "Sherman Oaks",
        "state": "CA",
        "postalCode": "91403",
        "country": "United States",
        "phone": "(818) 783-0322"
      },
      {
        "name": "Soundscape Audiology",
        "address": "433 N 4th St Suite 205-B",
        "city": "Montebello",
        "state": "CA",
        "postalCode": "90640",
        "country": "United States",
        "phone": "(704) 787-1109"
      },
      {
        "name": "LA Center for Hearing & Balance - DTLA",
        "address": "1414 S Grand Ave Suite 123",
        "city": "Los Angeles",
        "state": "CA",
        "postalCode": "90015",
        "country": "United States",
        "phone": "(323) 306-9632 ext. 1086"
      },
      {
        "name": "LA Center for Hearing & Balance - Glendale",
        "address": "1577 E Chevy Chase Dr Suite 330",
        "city": "Glendale",
        "state": "CA",
        "postalCode": "91206",
        "country": "United States",
        "phone": "(323) 306-9632 ext. 1086"
      }
    ]
  },
  {
    "countryLabel": "",
    "stateLabel": "CO",
    "stateEntries": [
      {
        "name": "Aspen Hearing Center",
        "address": "950 E Harvard Ave",
        "city": "Denver",
        "state": "CO",
        "postalCode": "80210",
        "country": "United States",
        "phone": "(303) 722-0886"
      },
      {
        "name": "Hearing Rehab Center",
        "address": "1975 W 120th Ave #100",
        "city": "Westminster",
        "state": "CO",
        "postalCode": "80234",
        "country": "United States",
        "phone": "(303) 255-9595"
      },
      {
        "name": "Center For Hearing Speech and Language",
        "address": "4280 Hale Pkwy",
        "city": "Denver",
        "state": "CO",
        "postalCode": "80220",
        "country": "United States",
        "phone": "(303) 322-1871"
      },
      {
        "name": "Colorado Springs Audiology",
        "address": "1330 W Colorado Ave",
        "city": "Colorado Springs",
        "state": "CO ",
        "postalCode": "80904",
        "country": "United States",
        "phone": "(719) 520-1155"
      },
      {
        "name": "Summit Hearing Center",
        "address": "1817 N Union Blvd",
        "city": "Colorado Springs",
        "state": "CO",
        "postalCode": "80909",
        "country": "United States",
        "phone": "(719) 594-2095"
      },
      {
        "name": "Colorado ENT and Allergy",
        "address": "3030 N Circle Dr #300",
        "city": "Colorado Springs",
        "state": "CO",
        "postalCode": "80909",
        "country": "United States",
        "phone": "(719) 867-7800"
      }
    ]
  },
  {
    "countryLabel": "",
    "stateLabel": "CT",
    "stateEntries": [
      {
        "name": "AA Hearing Aid Center",
        "address": "4270 Main St",
        "city": "Bridgeport",
        "state": "CT",
        "postalCode": "06606",
        "country": "United States",
        "phone": "(203) 374-8900"
      },
      {
        "name": "Cottage Grove Audiology & Hearing Aids Inc.",
        "address": "4 Northwestern Dr.",
        "city": "Bloomfield",
        "state": "CT",
        "postalCode": "06002",
        "country": "United States",
        "phone": "(860) 243-9510"
      },
      {
        "name": "Pauline G Bailey",
        "address": "104 Newfield Dr. ",
        "city": "Stamford",
        "state": "CT",
        "postalCode": "06905",
        "country": "United States",
        "phone": "(203) 322-2942"
      }
    ]
  },
  {
    "countryLabel": "",
    "stateLabel": "DE",
    "stateEntries": [
      {
        "name": "Hearing Health Center",
        "address": "2205 Silverside Rd",
        "city": "Wilmington",
        "state": "DE",
        "postalCode": "19810",
        "country": "United States",
        "phone": "(302) 529-9103"
      },
      {
        "name": "Hearsay Hearing Centers",
        "address": "5 B Talley Square",
        "city": "Wilmington",
        "state": "DE",
        "postalCode": "19806",
        "country": "United States",
        "phone": "(302) 737-2270"
      }
    ]
  },
  {
    "countryLabel": "",
    "stateLabel": "FL",
    "stateEntries": [
      {
        "name": "Gilliom Audiology, PA",
        "address": "2051 Art Museum Dr.",
        "city": "Jacksonville",
        "state": "FL",
        "postalCode": "33207",
        "country": "United States",
        "phone": "(904) 399-3323"
      },
      {
        "name": "Audiology & Hearing Aid Services",
        "address": "12276 San Jose Blvd",
        "city": "Jacksonville",
        "state": "FL",
        "postalCode": "32223",
        "country": "United States",
        "phone": "(904) 262-5550"
      },
      {
        "name": "South Miami Audiology Consultants",
        "address": "7000 SW 62nd Ave #310",
        "city": "South Miami,",
        "state": "FL",
        "postalCode": "33143",
        "country": "United States",
        "phone": "(305) 663-0505"
      },
      {
        "name": "The Audiology & Vestibular Center",
        "address": "9150 SW 87th Ave #103",
        "city": "Miami",
        "state": "FL",
        "postalCode": "33176",
        "country": "United States",
        "phone": "(305) 595-1530"
      },
      {
        "name": "Miami Hearing Aid Center",
        "address": "3661 S Miami Ave #410",
        "city": "Miami",
        "state": "FL",
        "postalCode": "33133",
        "country": "United States",
        "phone": "(305) 854-8171"
      },
      {
        "name": "Progressive Hearing",
        "address": "2232 NE 123rd St",
        "city": "North Miami",
        "state": "FL",
        "postalCode": "33181",
        "country": "United States",
        "phone": "(786) 232-4977"
      },
      {
        "name": "Audiology & Hearing Center of Tampa",
        "address": "10860 Sheldon Rd",
        "city": "Tampa",
        "state": "FL",
        "postalCode": "33626",
        "country": "United States",
        "phone": "(813) 920-8777"
      },
      {
        "name": "Alvarez Audiology & Hearing",
        "address": "6615 Gunn Hwy",
        "city": "Tampa",
        "state": "FL",
        "postalCode": "33625",
        "country": "United States",
        "phone": "(813) 265-2255"
      },
      {
        "name": "Broadwater Hearing Care",
        "address": "4107 5th Ave N",
        "city": "St Petersburg",
        "state": "FL",
        "postalCode": "33713",
        "country": "United States",
        "phone": "(727) 323-2471"
      },
      {
        "name": "Gardner Audiology",
        "address": "970 Lake Carillon Dr.",
        "city": "St Petersburg",
        "state": "FL",
        "postalCode": "33713",
        "country": "United States",
        "phone": "(800) 277-1182"
      },
      {
        "name": "Hennessey Hearing LLC",
        "address": "1500 Apalachee Pkwy",
        "city": "Tallahassee",
        "state": "FL",
        "postalCode": "32301",
        "country": "United States",
        "phone": "(850) 386-7600"
      },
      {
        "name": "West-Med Hearing Center",
        "address": "201 NW 82nd Ave #406",
        "city": "Plantation",
        "state": "FL",
        "postalCode": "33324",
        "country": "United States",
        "phone": "(954) 423-8828"
      },
      {
        "name": "Georgakakis George E MD",
        "address": "4801 N Federal Hwy",
        "city": "Fort Lauderdale",
        "state": "FL",
        "postalCode": "33308",
        "country": "United States",
        "phone": "(954) 493-8773"
      },
      {
        "name": "Michael Colongo",
        "address": "309 SW 6 St",
        "city": "Hallandale Beach",
        "state": "FL",
        "postalCode": "33009",
        "country": "United States",
        "phone": "(305) 510-0505"
      },
      {
        "name": "Marilyn Navia",
        "address": "10265 NW 56 ST",
        "city": "Doral",
        "state": "FL",
        "postalCode": "33178",
        "country": "United States",
        "phone": "(786) 566-0701"
      },
      {
        "name": "Jax Audiology and Hearing Aid Center Inc",
        "address": "150 Warren Cir. Suite 5A",
        "city": "St Johns",
        "state": "FL",
        "postalCode": "32259",
        "country": "United States",
        "phone": "(904) 342-5217"
      }
    ]
  },
  {
    "countryLabel": "",
    "stateLabel": "GA",
    "stateEntries": [
      {
        "name": "Audiological Consultants Inc.",
        "address": "2140 Peachtree Rd NE",
        "city": "Atlanta",
        "state": "GA",
        "postalCode": "30309",
        "country": "United States",
        "phone": "(404) 351-4114"
      },
      {
        "name": "Sam&apos;s Hearing Aid Center",
        "address": "596 Bobby Jones Expy",
        "city": "Augusta",
        "state": "GA",
        "postalCode": "30907",
        "country": "United States",
        "phone": "(706) 854-9833"
      },
      {
        "name": "Columbus Speech & Hearing Center",
        "address": "2424 Double Churches Rd",
        "city": "Columbus",
        "state": "GA",
        "postalCode": "31909",
        "country": "United States",
        "phone": "(706) 324-6112"
      },
      {
        "name": "Savannah Speech & Hearing Center",
        "address": "1206 E 66th St",
        "city": "Savannah",
        "state": "GA",
        "postalCode": "31404",
        "country": "United States",
        "phone": "(912) 355-4601"
      },
      {
        "name": "Atlanta Hearing Associates",
        "address": "1713 Mt. Vernon Road, Suite #3",
        "city": "Atlanta",
        "state": "GA",
        "postalCode": "30338",
        "country": "United States",
        "phone": "(770) 574-4819"
      },
      {
        "name": "Atlanta Hearing Associates",
        "address": "1991 North Williamsburg Dr. Suite B",
        "city": "Atlanta",
        "state": "GA",
        "postalCode": "30033",
        "country": "United States",
        "phone": "(404) 500-1026"
      },
      {
        "name": "Hearing Associates",
        "address": "1051 Parkside Commons Suite 103",
        "city": "Greensboro",
        "state": "GA",
        "postalCode": "30642",
        "country": "United States",
        "phone": "(706) 763-4425"
      },
      {
        "name": "Hearing Associates",
        "address": "111 Field Stone Dr. Suite 106",
        "city": "Milledgeville",
        "state": "GA",
        "postalCode": "31061",
        "country": "United States",
        "phone": "(478) 387-4186"
      }
    ]
  },
  {
    "countryLabel": "",
    "stateLabel": "HI",
    "stateEntries": [
      {
        "name": "Aloha Hearing Aid Service Inc.",
        "address": "1481 S king St #527",
        "city": "Honolulu",
        "state": "HI",
        "postalCode": "96814",
        "country": "United States",
        "phone": "(808) 949-2833"
      },
      {
        "name": "Big Island Hearing Center",
        "address": "9 Lei St",
        "city": "Hilo",
        "state": "HI",
        "postalCode": "96720",
        "country": "United States",
        "phone": "(808) 935-1299"
      },
      {
        "name": "Family Hearing Aid Center",
        "address": "46-1 Kamehameha Hwy #1023",
        "city": "Kaneohe",
        "state": "HI",
        "postalCode": "96744",
        "country": "United States",
        "phone": "(808) 233-1100"
      },
      {
        "name": "Family Hearing Aid Center Ryan Himeda",
        "address": "1245 Kuala St.",
        "city": "Pearl City",
        "state": "HI",
        "postalCode": "96782",
        "country": "United States",
        "phone": "(808)483-4131"
      }
    ]
  },
  {
    "countryLabel": "",
    "stateLabel": "IA",
    "stateEntries": [
      {
        "name": "Steven Klungtvedt, Au.D.",
        "address": "3901 Ingersoll Ave",
        "city": "Des Moines",
        "state": "IA",
        "postalCode": "50312",
        "country": "United States",
        "phone": "(515) 274-4493"
      },
      {
        "name": "Cedar Rapids Hearing Center",
        "address": "1825 29th St NE #A ",
        "city": "Cedar Rapids",
        "state": "IA",
        "postalCode": "52402",
        "country": "United States",
        "phone": "(319) 286-8782"
      }
    ]
  },
  {
    "countryLabel": "",
    "stateLabel": "ID",
    "stateEntries": [
      {
        "name": "Audibel Hearing Aid Center",
        "address": "106 Holly St.",
        "city": "Nampa",
        "state": "ID",
        "postalCode": "83686",
        "country": "United States",
        "phone": "(208) 899-4223"
      },
      {
        "name": "Audiology & Hearing Aid Center",
        "address": "1740 N Milwaukee St",
        "city": "Boise",
        "state": "ID",
        "postalCode": "83704",
        "country": "United States",
        "phone": "(208) 658-0238"
      },
      {
        "name": "Treasury Valley Hearing",
        "address": "745 S Progress Ave",
        "city": "Meridian",
        "state": "ID",
        "postalCode": "83642",
        "country": "United States",
        "phone": "(208) 377-0019"
      },
      {
        "name": "Hearing Solutions",
        "address": "211 S Woodruff Ave",
        "city": "Idaho Falls",
        "state": "ID",
        "postalCode": "83401",
        "country": "United States",
        "phone": "(208) 542-1112"
      },
      {
        "name": "Miracle-Ear Hear Aid Center",
        "address": "2350 Via Caporatti Dr",
        "city": "Pocatello",
        "state": "ID",
        "postalCode": "83201",
        "country": "United States",
        "phone": "(208) 398-3567"
      }
    ]
  },
  {
    "countryLabel": "",
    "stateLabel": "IL",
    "stateEntries": [
      {
        "name": "Hearing Health Center",
        "address": "142 E Ontario St #1100",
        "city": "Chicago",
        "state": "IL",
        "postalCode": "60611",
        "country": "United States",
        "phone": "(312) 263-7171"
      },
      {
        "name": "Chicago Hearing Services PC",
        "address": "5600 W Addison St",
        "city": "Chicago",
        "state": "IL",
        "postalCode": "60634",
        "country": "United States",
        "phone": "(773) 685-9202"
      },
      {
        "name": "Hearing Healthcare of Illinois",
        "address": "435 N Mulford Rd #10",
        "city": "Rockford",
        "state": "IL",
        "postalCode": "61107",
        "country": "United States",
        "phone": "(815) 399-5279"
      },
      {
        "name": "Professional Hearing & Audiology Clinics",
        "address": "1415 E State St",
        "city": "Rockford",
        "state": "IL",
        "postalCode": "61104",
        "country": "United States",
        "phone": "(815) 964-3131"
      },
      {
        "name": "Prairieland Audiology LLC",
        "address": "2121 Oneida St",
        "city": "Joliet",
        "state": "IL",
        "postalCode": "60435",
        "country": "United States",
        "phone": "(815) 744-5661"
      },
      {
        "name": "Advance Hearing Systems",
        "address": "3143 W Jefferson St",
        "city": "Joliet",
        "state": "IL",
        "postalCode": "60435",
        "country": "United States",
        "phone": "(815) 744-6898"
      },
      {
        "name": "Hearing Health Center Inc.",
        "address": "636 Raymond Dr. #203",
        "city": "Naperville",
        "state": "IL",
        "postalCode": "60563",
        "country": "United States",
        "phone": "(630) 369-8878"
      },
      {
        "name": "Naperville Hearing Services",
        "address": "10 W Martin Ave",
        "city": "Naperville",
        "state": "IL",
        "postalCode": "60540",
        "country": "United States",
        "phone": "(630) 357-5287"
      },
      {
        "name": "Hearing Specialists of DuPage Danada Professional Center",
        "address": "2323 Naperville Rd.  Suite 200",
        "city": "Naperville",
        "state": "IL",
        "postalCode": "60563",
        "country": "United States",
        "phone": "(630) 580-5777"
      },
      {
        "name": "Hearing Specialists of DuPage Wiesman Institute",
        "address": "712 N. Dearborn St.",
        "city": "Chicago",
        "state": "IL",
        "postalCode": "60654",
        "country": "United States",
        "phone": "(630) 580-5777"
      }
    ]
  },
  {
    "countryLabel": "",
    "stateLabel": "IN",
    "stateEntries": [
      {
        "name": "Indiana Hearing Aid Company",
        "address": "3843 Moller Rd",
        "city": "Indianapolis",
        "state": "IN",
        "postalCode": "46254",
        "country": "United States",
        "phone": "(317) 291-3376"
      },
      {
        "name": "Community Hearing Health Center",
        "address": "8202 Clearvista Ln",
        "city": "Indianapolis",
        "state": "IN",
        "postalCode": "46254",
        "country": "United States",
        "phone": "(317) 291-3376"
      },
      {
        "name": "Hearcare Audiology",
        "address": "5933 E State Blvd",
        "city": "Fort Wayne",
        "state": "IN",
        "postalCode": "46815",
        "country": "United States",
        "phone": "(260) 485-1231"
      },
      {
        "name": "Focus Audiology & Hearing Services",
        "address": "9604 Coldwater Rd #109",
        "city": "Fort Wayne",
        "state": "IN",
        "postalCode": "46825",
        "country": "United States",
        "phone": "(260) 479-7844"
      }
    ]
  },
  {
    "countryLabel": "",
    "stateLabel": "KS",
    "stateEntries": [
      {
        "name": "Associated Audiologists, Inc.",
        "address": "8800 W. 75th St #101",
        "city": "Shawnee Mission",
        "state": "KS",
        "postalCode": "66204",
        "country": "United States",
        "phone": "(913) 403-0018"
      },
      {
        "name": "Associated Audiologists, Inc.",
        "address": "1133 College Ave #101A",
        "city": "Manhattan",
        "state": "KS",
        "postalCode": "66502",
        "country": "United States",
        "phone": "(785) 539-7361"
      },
      {
        "name": "Associated Audiologists, Inc.",
        "address": "7301 Mission Road #140",
        "city": "Prairie Village",
        "state": "KS",
        "postalCode": "66208",
        "country": "United States",
        "phone": "(913) 262-5855"
      },
      {
        "name": "Associated Audiologists, Inc.",
        "address": "1001 W 6th Ave #105 ",
        "city": "Leavenworth",
        "state": "KS",
        "postalCode": "66048",
        "country": "United States",
        "phone": "(913) 682-1870"
      },
      {
        "name": "Associated Audiologists, Inc.",
        "address": "12541 Foster, #220 ",
        "city": "Overland Park",
        "state": "KS",
        "postalCode": "66213",
        "country": "United States",
        "phone": "(913) 498-2827"
      }
    ]
  },
  {
    "countryLabel": "",
    "stateLabel": "KY",
    "stateEntries": [
      {
        "name": "William J Brown & Associates Inc.",
        "address": "4001 Dutchmans Ln.",
        "city": "St Matthews",
        "state": "KY",
        "postalCode": "40207",
        "country": "United States",
        "phone": "(502) 893-5105"
      },
      {
        "name": "Chambers Hearing Aid Services",
        "address": "730 Fairview Ave ",
        "city": "Bowling Green",
        "state": "KY",
        "postalCode": "42101",
        "country": "United States",
        "phone": "(270) 842-8932"
      },
      {
        "name": "Beltone Hearing Aid Center",
        "address": "2309 Frederica",
        "city": "St Owensboro",
        "state": "KY",
        "postalCode": "42301",
        "country": "United States",
        "phone": "(270) 926-6822"
      },
      {
        "name": "Owensboro Hearing Aid Center",
        "address": "411 E 18th St ",
        "city": "Owensboro",
        "state": "KY",
        "postalCode": "42303",
        "country": "United States",
        "phone": "(270) 685-5566"
      }
    ]
  },
  {
    "countryLabel": "",
    "stateLabel": "LA",
    "stateEntries": [
      {
        "name": "Kim Juneau Hearing LLC",
        "address": "175 Brookhollow Esplanade",
        "city": "New Orleans",
        "state": "LA",
        "postalCode": "70123",
        "country": "United States",
        "phone": "(504) 733-3745"
      },
      {
        "name": "Clinic of Ear Nose & Throat",
        "address": "710 Colonial Dr.",
        "city": "Baton Rouge",
        "state": "LA",
        "postalCode": "70806",
        "country": "United States",
        "phone": "(225) 927-5325"
      },
      {
        "name": "Ear Nose & Throat Center AMC",
        "address": "2121 Line Ave",
        "city": "Shreveport",
        "state": "LA",
        "postalCode": "71104",
        "country": "United States",
        "phone": "(318) 226-9441"
      },
      {
        "name": "Audibel of Shreveport",
        "address": "701 Jordan St",
        "city": "Shreveport",
        "state": "LA",
        "postalCode": "71101",
        "country": "United States",
        "phone": "(318) 425-5417"
      },
      {
        "name": "Doctor's Hearing Center",
        "address": "5258 Veterans Memorial Blvd",
        "city": "Metairie",
        "state": "LA",
        "postalCode": "70006",
        "country": "United States",
        "phone": "(504) 887-5858"
      },
      {
        "name": "ACI Hearing & Balance Center",
        "address": "315 S College Rd",
        "city": "Lafayette",
        "state": "LA",
        "postalCode": "70503",
        "country": "United States",
        "phone": "(337) 235-6601"
      },
      {
        "name": "Cajun Hearing Centers",
        "address": "1232 Camellia Blvd",
        "city": "Lafayette",
        "state": "LA",
        "postalCode": "70508",
        "country": "United States",
        "phone": "(337) 235-5437"
      }
    ]
  },
  {
    "countryLabel": "",
    "stateLabel": "MA",
    "stateEntries": [
      {
        "name": "Audiology Associates-Worcester",
        "address": "130 Lincoln St",
        "city": "Worcester",
        "state": "MA",
        "postalCode": "01605",
        "country": "United States",
        "phone": "(508) 792-9293"
      },
      {
        "name": "Audio Hearing Center",
        "address": "77 E Merrimack St",
        "city": "Lowell",
        "state": "MA",
        "postalCode": "01852",
        "country": "United States",
        "phone": "(978) 454-1966"
      },
      {
        "name": "Preferred Hearing Care LLC",
        "address": "60 State St #700",
        "city": "Boston",
        "state": "MA",
        "postalCode": "02109",
        "country": "United States",
        "phone": "(866) 330-4327"
      },
      {
        "name": "Advanced Hearing Care Inc.",
        "address": "1324 Belmont St",
        "city": "Brockton",
        "state": "MA",
        "postalCode": "02301",
        "country": "United States",
        "phone": "(508) 559-9200"
      },
      {
        "name": "Beltone New England",
        "address": "513 State Rd North Dartmouth",
        "city": "New Bedford",
        "state": "MA",
        "postalCode": "02747",
        "country": "United States",
        "phone": "(508) 689-5849"
      },
      {
        "name": "Holden Hearing Aid Center, Inc.",
        "address": "695 Main St.",
        "city": "Holden",
        "state": "MA",
        "postalCode": "01520",
        "country": "United States",
        "phone": "(508) 829-5566"
      },
      {
        "name": "Preferred Hearing Care LLC",
        "address": "5 E. Main Street, Suite #1",
        "city": "Merrimac",
        "state": "MA",
        "postalCode": "01860",
        "country": "United States",
        "phone": "(978) 346-4400"
      }
    ]
  },
  {
    "countryLabel": "",
    "stateLabel": "MD",
    "stateEntries": [
      {
        "name": "The Hearing and Speech Agency",
        "address": "5900 Metro Dr.",
        "city": "Baltimore",
        "state": "MD",
        "postalCode": "21215",
        "country": "United States",
        "phone": "(410) 318-6780"
      },
      {
        "name": "Audiology Associations",
        "address": "3455 Wilkens Ave.",
        "city": "Baltimore",
        "state": "MD",
        "postalCode": "21229",
        "country": "United States",
        "phone": "(410) 944-3100"
      },
      {
        "name": "The Kaplan Hearing Center",
        "address": "8818 Centre Park Dr.",
        "city": "Columbia",
        "state": "MD",
        "postalCode": "21045",
        "country": "United States",
        "phone": "(410) 740-4885"
      }
    ]
  },
  {
    "countryLabel": "",
    "stateLabel": "ME",
    "stateEntries": [
      {
        "name": "Fagan Hearing",
        "address": "985 Forest Ave",
        "city": "Portland",
        "state": "ME",
        "postalCode": "04103",
        "country": "United States",
        "phone": "(207) 797-8738"
      },
      {
        "name": "Sand Castle Maine",
        "address": "72 Strawberry Ave",
        "city": "Lewiston",
        "state": "ME",
        "postalCode": "04240",
        "country": "United States",
        "phone": "(207) 782-2150"
      },
      {
        "name": "Soulas Associates Hearing Aids",
        "address": "263 State St",
        "city": "Bangor",
        "state": "ME",
        "postalCode": "04401",
        "country": "United States",
        "phone": "(207) 945-5639"
      }
    ]
  },
  {
    "countryLabel": "",
    "stateLabel": "MI",
    "stateEntries": [
      {
        "name": "Henry Ford Hearing Aid Services",
        "address": "2799 W Grand Blvd",
        "city": "Detroit",
        "state": "MI",
        "postalCode": "48202",
        "country": "United States",
        "phone": "(313) 916-3272"
      },
      {
        "name": "Lucas Hearing Aid Services",
        "address": "26501 Hoover Rd",
        "city": "Warren",
        "state": "MI",
        "postalCode": "48089",
        "country": "United States",
        "phone": "(586) 754-2230"
      },
      {
        "name": "Hearing Consultants, Inc.",
        "address": "28111 Hoover Rd",
        "city": "Warren",
        "state": "MI",
        "postalCode": "48093",
        "country": "United States",
        "phone": "(586) 558-7477"
      },
      {
        "name": "Henry Ford Hearing Aid Services",
        "address": "14500 Hall Rd",
        "city": "Sterling Heights",
        "state": "MI",
        "postalCode": "48313",
        "country": "United States",
        "phone": "(586) 566-4286"
      },
      {
        "name": "Kathryn E. Debler, Audiologist",
        "address": "6512 Centurion Dr. #340",
        "city": "Lansing",
        "state": "MI",
        "postalCode": "48912",
        "country": "United States",
        "phone": "(517) 323-6222"
      },
      {
        "name": "Hearing Health Center",
        "address": "1200 E Michigan Ave #330",
        "city": "Lansing",
        "state": "MI",
        "postalCode": "48912",
        "country": "United States",
        "phone": "(517) 364-5678"
      }
    ]
  },
  {
    "countryLabel": "",
    "stateLabel": "MN",
    "stateEntries": [
      {
        "name": "Audiologists Hearing Center Inc.",
        "address": "825 Nicollet Mall",
        "city": "Minneapolis",
        "state": "MN",
        "postalCode": "55402",
        "country": "United States",
        "phone": "(612) 339-4532"
      },
      {
        "name": "Avada Audiology & Hearing Care",
        "address": "4080 W Broadway Ave",
        "city": "Robbinsdale",
        "state": "MN",
        "postalCode": "55422",
        "country": "United States",
        "phone": "(763) 971-7878"
      },
      {
        "name": "Associated Hearing of St Paul",
        "address": "393 N Dunlap St.",
        "city": "St Paul",
        "state": "MN",
        "postalCode": "55104",
        "country": "United States",
        "phone": "(651) 646-2427"
      },
      {
        "name": "Minnesota Hearing Aid Pro Inc.",
        "address": "347 Smith Ave,",
        "city": "St Paul",
        "state": "MN",
        "postalCode": "55102",
        "country": "United States",
        "phone": "(651) 227-0824"
      },
      {
        "name": "Hearing Associates",
        "address": "4905 Matterhorn Dr.",
        "city": "Duluth",
        "state": "MN",
        "postalCode": "55811",
        "country": "United States",
        "phone": "(218) 723-7880"
      },
      {
        "name": "Hearing Plus",
        "address": "2522 Maple Grove Rd ",
        "city": "Duluth",
        "state": "MN",
        "postalCode": "55811",
        "country": "United States",
        "phone": "(218) 727-2333"
      },
      {
        "name": "Audiologists Hearing Center Inc.",
        "address": "6550 York Ave",
        "city": "S Edina",
        "state": "MN",
        "postalCode": "55435",
        "country": "United States",
        "phone": "(952) 285-1419"
      }
    ]
  },
  {
    "countryLabel": "",
    "stateLabel": "MO",
    "stateEntries": [
      {
        "name": "Hometown Hearing & Audiology",
        "address": "4240 Blue Ridge Blvd",
        "city": "Kansas City",
        "state": "MO",
        "postalCode": "64133",
        "country": "United States",
        "phone": "(816) 313-2800"
      },
      {
        "name": "Echo Hearing Systems",
        "address": "4240 Blue Ridge Blvd",
        "city": "Kansas City",
        "state": "MO",
        "postalCode": "64133",
        "country": "United States",
        "phone": "(816) 356-3333"
      },
      {
        "name": "Southwestern Hearing Centers",
        "address": "36 Hampton Village Plaza",
        "city": "St. Louis",
        "state": "MO",
        "postalCode": "63109",
        "country": "United States",
        "phone": "(314) 481-6005"
      },
      {
        "name": "Hearing Express Laboratory",
        "address": "3010 Missouri 291",
        "city": "Independence",
        "state": "MO",
        "postalCode": "64057",
        "country": "United States",
        "phone": "(816) 478-0200"
      },
      {
        "name": "Hear USA/Hearing Associates",
        "address": "4200 Little Blue Pkwy",
        "city": "Independence",
        "state": "MO",
        "postalCode": "64057",
        "country": "United States",
        "phone": "(816) 994-2401"
      },
      {
        "name": "Columbia Hearing Center",
        "address": "1306 Old Hwy 63 South Suite B",
        "city": "Columbia",
        "state": "MO",
        "postalCode": "65201",
        "country": "United States",
        "phone": "(573) 875-4327"
      },
      {
        "name": "Hear USA/ Better Hearing Centers",
        "address": "1001 NW Chipman Rd.",
        "city": "Lees Summit",
        "state": "MO",
        "postalCode": "64081",
        "country": "United States",
        "phone": "(816) 875-4520"
      },
      {
        "name": "ENT Associates of Greater Kansas City, PC",
        "address": "1004 Carondelet Dr. Suite 450",
        "city": "Kansas City",
        "state": "MO",
        "postalCode": "64114",
        "country": "United States",
        "phone": "(816) 942-7200"
      },
      {
        "name": "ENT Associates of Greater Kansas City, PC",
        "address": "4880 NE Goodview Circle ",
        "city": "Lees Summit",
        "state": "MO",
        "postalCode": "64064",
        "country": "United States",
        "phone": "(816) 478-4200"
      },
      {
        "name": "ENT Associates of Greater Kansas City, PC",
        "address": "205 W. R.D. Mize Rd Suite 208",
        "city": "Blue Springs",
        "state": "MO",
        "postalCode": "64014",
        "country": "United States",
        "phone": "(816) 229-7474"
      }
    ]
  },
  {
    "countryLabel": "",
    "stateLabel": "MS",
    "stateEntries": [
      {
        "name": "The Better Communication Clinic",
        "address": "5439 W Aloha Dr.",
        "city": "Diamondhead",
        "state": "MS",
        "postalCode": "39525",
        "country": "United States",
        "phone": "(228) 255-8889"
      },
      {
        "name": "Hearing & Balance Center",
        "address": "3017 13th St",
        "city": "Gulfport",
        "state": "MS",
        "postalCode": "39501",
        "country": "United States",
        "phone": "(228) 863-6592"
      },
      {
        "name": "Sam's Hearing Aid Center",
        "address": "10431 Old Highway 49 ",
        "city": "Gulfport",
        "state": "MS",
        "postalCode": "39503",
        "country": "United States",
        "phone": "(228) 832-8399"
      }
    ]
  },
  {
    "countryLabel": "",
    "stateLabel": "MT",
    "stateEntries": [
      {
        "name": "Miracle-Ear of Billings",
        "address": "1527 14th St",
        "city": "West Billings",
        "state": "MT",
        "postalCode": "59102",
        "country": "United States",
        "phone": "(406) 686-1554"
      },
      {
        "name": "Miracle-Ear of Bozeman",
        "address": "702 N 19th Ave, Ste 1-C",
        "city": "Bozeman",
        "state": "MT",
        "postalCode": "59718",
        "country": "United States",
        "phone": "(406) 686-1554"
      },
      {
        "name": "Miracle-Ear of Butte",
        "address": "3703 Harrison Ave",
        "city": "Butte",
        "state": "MT",
        "postalCode": "59701",
        "country": "United States",
        "phone": "(888) 401-2628"
      },
      {
        "name": "Miracle-Ear Of Great Falls",
        "address": "215 10th St S",
        "city": "Great Falls",
        "state": "MT",
        "postalCode": "59405",
        "country": "United States",
        "phone": "(406) 748-6962"
      },
      {
        "name": "Miracle-Ear of Havre",
        "address": "1753 Hwy 2 NW, Ste 40A",
        "city": "Havre",
        "state": "MT",
        "postalCode": "59501",
        "country": "United States",
        "phone": "(888) 393-0913"
      },
      {
        "name": "Miracle-Ear of Helena",
        "address": "1123 Euchlid",
        "city": "Helena",
        "state": "MT",
        "postalCode": "59601",
        "country": "United States",
        "phone": "(888) 361-3548"
      },
      {
        "name": "Miracle-Ear of Miles City",
        "address": "18 North 8th Ste 8",
        "city": "Miles City",
        "state": "MT",
        "postalCode": "59301",
        "country": "United States",
        "phone": "(888) 422-7591"
      },
      {
        "name": "Miracle-Ear Of Missoula",
        "address": "712 West Spruce Street, Ste #2",
        "city": "Missoula",
        "state": "MT",
        "postalCode": "59802",
        "country": "United States",
        "phone": "(406) 414-6073"
      }
    ]
  },
  {
    "countryLabel": "",
    "stateLabel": "NC",
    "stateEntries": [
      {
        "name": "Ear Nose Throat and Audiology Associates of the Carolinas, PA",
        "address": "7006 Shannon Willow Rd",
        "city": "Charlotte",
        "state": "NC",
        "postalCode": "28226",
        "country": "United States",
        "phone": "(704) 544-6533"
      },
      {
        "name": "Charlotte Eye Ear Nose & Throat Associates",
        "address": "6035 Fairview Rd",
        "city": "Charlotte",
        "state": "NC",
        "postalCode": "28210",
        "country": "United States",
        "phone": "(704) 295-3000"
      },
      {
        "name": "N C Audiology Associates",
        "address": "4002 Barrett Dr #101",
        "city": "Raleigh",
        "state": "NC",
        "postalCode": "27609",
        "country": "United States",
        "phone": "(919) 783-8751"
      }
    ]
  },
  {
    "countryLabel": "",
    "stateLabel": "ND",
    "stateEntries": [
      {
        "name": "Miracle-Ear Hearing Aid Center",
        "address": "2331 Tyler Pkwy #1",
        "city": "Bismarck",
        "state": "ND",
        "postalCode": "58503",
        "country": "United States",
        "phone": "(701) 433-1627"
      },
      {
        "name": "Professional Hearing Services",
        "address": "1400 37th Ave SW",
        "city": "Minot",
        "state": "ND",
        "postalCode": "58701",
        "country": "United States",
        "phone": "(701) 852-6565"
      }
    ]
  },
  {
    "countryLabel": "",
    "stateLabel": "NE",
    "stateEntries": [
      {
        "name": "Professional Audiology Center",
        "address": "4509 Leavenworth St",
        "city": "Omaha",
        "state": "NE",
        "postalCode": "68106",
        "country": "United States",
        "phone": "(402) 558-0440"
      },
      {
        "name": "Ear Specialists of Omaha",
        "address": "9202 W Dodge Rd",
        "city": "Omaha",
        "state": "NE",
        "postalCode": "68114",
        "country": "United States",
        "phone": "(402) 933-3277"
      },
      {
        "name": "Central Plains Ent & Audiology",
        "address": "8005 Farnam Dr",
        "city": "Omaha",
        "state": "NE",
        "postalCode": "68114",
        "country": "United States",
        "phone": "(402) 502-6970"
      },
      {
        "name": "Christensen Audiology & Hearing Aid Center",
        "address": "7700 A St #100",
        "city": "Lincoln",
        "state": "NE",
        "postalCode": "68510",
        "country": "United States",
        "phone": "(402) 489-3450"
      },
      {
        "name": "Complete Hearing Solutions, PC",
        "address": "1530 S 70th St",
        "city": "Lincoln",
        "state": "NE",
        "postalCode": "68506",
        "country": "United States",
        "phone": "(402) 489-4418"
      }
    ]
  },
  {
    "countryLabel": "",
    "stateLabel": "NH",
    "stateEntries": [
      {
        "name": "Manning Carol Ann",
        "address": "3 Webb Pl",
        "city": "Dover",
        "state": "NH",
        "postalCode": "03820",
        "country": "United States",
        "phone": "(603) 749-1780"
      },
      {
        "name": "Concord Otolaryngology",
        "address": "194 Pleasant St",
        "city": "Concord",
        "state": "NH",
        "postalCode": "03301",
        "country": "United States",
        "phone": "(603) 224-2353"
      },
      {
        "name": "Albuquerque Hearing Associates",
        "address": "10700 Corrales Rd NW",
        "city": "Albuquerque",
        "state": "NH",
        "postalCode": "87114",
        "country": "United States",
        "phone": "(505) 890-0003"
      },
      {
        "name": "Livingston Audiology & Hearing Aid Center",
        "address": "3821 Menaul Blvd NE",
        "city": "Albuquerque",
        "state": "NH",
        "postalCode": "87110",
        "country": "United States",
        "phone": "(505) 715-6763"
      }
    ]
  },
  {
    "countryLabel": "",
    "stateLabel": "NJ",
    "stateEntries": [
      {
        "name": "REM Audiology Associates, P.C.",
        "address": "1000 White Horse Rd #510",
        "city": "Voorhees Township",
        "state": "NJ",
        "postalCode": "08043",
        "country": "United States",
        "phone": "(856) 627-4400"
      },
      {
        "name": "North Jersey  Hearing Aid Center",
        "address": "195 Fairfield Ave. Suite 4B",
        "city": "West Caldwell",
        "state": "NJ",
        "postalCode": "07006",
        "country": "United States",
        "phone": "(201) 787-4368"
      },
      {
        "name": "North Jersey Hearing Aid Center",
        "address": "213 Park St.",
        "city": "Montclair",
        "state": "NJ",
        "postalCode": "07042",
        "country": "United States",
        "phone": "(201) 787-4368"
      }
    ]
  },
  {
    "countryLabel": "",
    "stateLabel": "NV",
    "stateEntries": [
      {
        "name": "Anderson Audiology",
        "address": "9430 W Lake Mead Blvd",
        "city": "Las Vegas",
        "state": "NV",
        "postalCode": "89134",
        "country": "United States",
        "phone": "(702) 527-6066"
      },
      {
        "name": "Desert Valley Audiology",
        "address": "501 S Rancho Dr A6",
        "city": "Las Vegas",
        "state": "NV",
        "postalCode": "89106",
        "country": "United States",
        "phone": "(702) 605-9133"
      },
      {
        "name": "Rainford Hearing Aid Services",
        "address": "440 E Sahara Ave",
        "city": "Las Vegas",
        "state": "NV",
        "postalCode": "89104",
        "country": "United States",
        "phone": "(702) 732-8721"
      },
      {
        "name": "Anderson Audiology",
        "address": "2642 W Horizon Ridge Pkwy",
        "city": "Henderson",
        "state": "NV",
        "postalCode": "89052",
        "country": "United States",
        "phone": "(702) 933-9102"
      }
    ]
  },
  {
    "countryLabel": "",
    "stateLabel": "NY",
    "stateEntries": [
      {
        "name": "New York Audiology",
        "address": "136-18 39th Ave Suite 1005",
        "city": "Flushing",
        "state": "NY",
        "postalCode": "11354",
        "country": "United States",
        "phone": "(718) 968-3333"
      },
      {
        "name": "New York Hearing Center Inc.",
        "address": "128 Mott St. Suite 509",
        "city": "New York",
        "state": "NY",
        "postalCode": "10013",
        "country": "United States",
        "phone": "(212) 966-3886"
      },
      {
        "name": "New York Hearing Center Inc.",
        "address": "726 60th St.",
        "city": "Brooklyn",
        "state": "NY",
        "postalCode": "11220",
        "country": "United States",
        "phone": "(718) 569-0106"
      },
      {
        "name": "Dominick Servedio, Au.D",
        "address": "200 West 57th Street, Suite 910",
        "city": "New York",
        "state": "NY",
        "postalCode": "10019",
        "country": "United States",
        "phone": "(917) 441-6094"
      },
      {
        "name": "Advanced Audiology Of NY",
        "address": "102 E. Route 59",
        "city": "Nanuet",
        "state": "NY",
        "postalCode": "10954",
        "country": "United States",
        "phone": "(845) 501-7337"
      },
      {
        "name": "Advanced Audiology Of NY",
        "address": "390 Crystal Run Rd. Suite 105",
        "city": "Middletown",
        "state": "NY ",
        "postalCode": "10941",
        "country": "United States",
        "phone": "(845) 703-8118"
      },
      {
        "name": "Advanced Audiology Of NY",
        "address": "111 Brook St. Suite 204",
        "city": "Scarsdale",
        "state": "NY",
        "postalCode": "10583",
        "country": "United States",
        "phone": "(914) 395-3277"
      }
    ]
  },
  {
    "countryLabel": "",
    "stateLabel": "OH",
    "stateEntries": [
      {
        "name": "Dawn B. McKinney, AuD.",
        "address": "5920 Wilcox Place, Suite B",
        "city": "Dublin",
        "state": "OH",
        "postalCode": "43016",
        "country": "United States",
        "phone": "(614) 442-7680"
      },
      {
        "name": "Hill Hear Better",
        "address": "8250 Winton Rd #300",
        "city": "Cincinnati",
        "state": "OH",
        "postalCode": "45231",
        "country": "United States",
        "phone": "(513) 522-9936"
      },
      {
        "name": "Cincinnati Hearing Center",
        "address": "6570 Glenway Ave",
        "city": "Cincinnati",
        "state": "OH",
        "postalCode": "45211",
        "country": "United States",
        "phone": "(513) 598-9444"
      }
    ]
  },
  {
    "countryLabel": "",
    "stateLabel": "OK",
    "stateEntries": [
      {
        "name": "Audio Recovery, Inc.",
        "address": "3400 NW 56th St #100",
        "city": "Oklahoma City",
        "state": "OK",
        "postalCode": "73112",
        "country": "United States",
        "phone": "(405) 949-1906"
      },
      {
        "name": "American Hearing Aid Center & Audiology Services",
        "address": "5820 N May Ave",
        "city": "Oklahoma City",
        "state": "OK",
        "postalCode": "73107",
        "country": "United States",
        "phone": "(405) 842-8377"
      }
    ]
  },
  {
    "countryLabel": "",
    "stateLabel": "PA",
    "stateEntries": [
      {
        "name": "Hearsay Hearing Centers",
        "address": "1849 S. Broad St.",
        "city": "Philadelphia",
        "state": "PA",
        "postalCode": "19148",
        "country": "United States",
        "phone": "(215) 352-5928"
      },
      {
        "name": "Pittsburgh Audiology & Hearing Aid Center, Inc.",
        "address": "1145 Bower Hill Road, Suite 102",
        "city": "Pittsburgh",
        "state": "PA",
        "postalCode": "15243",
        "country": "United States",
        "phone": "(412) 279-2181"
      },
      {
        "name": "Pittsburgh Audiology & Hearing Aid Center, Inc.",
        "address": "3000 Brownsville Rd",
        "city": "Pittsburgh",
        "state": "PA",
        "postalCode": "15227",
        "country": "United States",
        "phone": "(412) 884-8499"
      },
      {
        "name": "Pittsburgh Audiology & Hearing Aid Center, Inc.",
        "address": "9335 McKnight Rd #104",
        "city": "Pittsburgh",
        "state": "PA",
        "postalCode": "15237",
        "country": "United States",
        "phone": "(724) 934-8744"
      },
      {
        "name": "Pittsburgh Audiology & Hearing Aid Center, Inc.",
        "address": "9066 Perry Hwy",
        "city": "Pittsburgh",
        "state": "PA",
        "postalCode": "15237",
        "country": "United States",
        "phone": "(412) 364-5744"
      },
      {
        "name": "Pittsburgh Audiology & Hearing Aid Center, Inc.",
        "address": "963 Beaver Grade Road",
        "city": "Coraopolis",
        "state": "PA",
        "postalCode": "15108",
        "country": "United States",
        "phone": "(412) 424-0444"
      }
    ]
  },
  {
    "countryLabel": "",
    "stateLabel": "PR",
    "stateEntries": [
      {
        "name": "Voice & Sinus Institute Torre M\u00e9dica Auxilio Mutuo",
        "address": "735 Ave Ponce de Le\u00f3n Ave. Suite 214",
        "city": "San Juan ",
        "state": "PR",
        "postalCode": "00917",
        "country": "United States",
        "phone": "(787) 766-1900"
      }
    ]
  },
  {
    "countryLabel": "",
    "stateLabel": "RI",
    "stateEntries": [
      {
        "name": "Physicians Hearing Solutions",
        "address": "3520 Post Rd",
        "city": "Warwick",
        "state": "RI",
        "postalCode": "02886",
        "country": "United States",
        "phone": "(401) 921-0181"
      }
    ]
  },
  {
    "countryLabel": "",
    "stateLabel": "SC",
    "stateEntries": [
      {
        "name": "Palmetto Hearing",
        "address": "7132 Parklane Rd",
        "city": "Columbia",
        "state": "SC",
        "postalCode": "29223",
        "country": "United States",
        "phone": "(803) 788-6688"
      },
      {
        "name": "Carolina Hearing Services",
        "address": "7132 Parklane Rd, Suite D",
        "city": "Columbia",
        "state": "SC",
        "postalCode": "29223",
        "country": "United States",
        "phone": "(843) 556-4327"
      },
      {
        "name": "The Audiology Center, Inc.",
        "address": "1364 Ebenezer Rd",
        "city": "Rock Hill",
        "state": "SC",
        "postalCode": "29732",
        "country": "United States",
        "phone": "(803) 327-1900"
      }
    ]
  },
  {
    "countryLabel": "",
    "stateLabel": "SD",
    "stateEntries": [
      {
        "name": "Audiology Specialty Clinic",
        "address": "5124 S Western Ave #4",
        "city": "Sioux Falls",
        "state": "SD",
        "postalCode": "57108",
        "country": "United States",
        "phone": "(605) 275-5545"
      },
      {
        "name": "Northern Hills Hearing Aid Center",
        "address": "1109 W Omaha St",
        "city": "Rapid City",
        "state": "SD",
        "postalCode": "57701",
        "country": "United States",
        "phone": "(605) 791-4327"
      }
    ]
  },
  {
    "countryLabel": "",
    "stateLabel": "TN",
    "stateEntries": [
      {
        "name": "Memphis Hearing Aid",
        "address": "7675 Wolf River Cr",
        "city": "Germantown",
        "state": "TN",
        "postalCode": "38134",
        "country": "United States",
        "phone": "(901) 757-4008"
      },
      {
        "name": "Professional Audiological Services",
        "address": "5108 Stage Rd",
        "city": "Memphis",
        "state": "TN",
        "postalCode": "38134",
        "country": "United States",
        "phone": "(901) 372-0040"
      },
      {
        "name": "Hearing Services of Nashville",
        "address": "7640 U.S. 70S #207",
        "city": "Nashville",
        "state": "TN",
        "postalCode": "37221",
        "country": "United States",
        "phone": "(615) 673-6100"
      },
      {
        "name": "Brentwood Hearing Center",
        "address": "5544 Franklin Pike #100",
        "city": "Nashville",
        "state": "TN",
        "postalCode": "37027",
        "country": "United States",
        "phone": "(615) 377-0420"
      },
      {
        "name": "Integrity Hearing of Nashville",
        "address": "2909 McGavock Pike",
        "city": "Nashville",
        "state": "TN",
        "postalCode": "37214",
        "country": "United States",
        "phone": "(615) 883-8619"
      },
      {
        "name": "Jenny H. Griggs",
        "address": "Nashville & Surrounding Areas",
        "city": "Nashville",
        "state": "TN",
        "postalCode": "37214",
        "country": "United States",
        "phone": "(615) 426-8326"
      },
      {
        "name": "Audiology & Hearing Health",
        "address": "3443 Dickerson Pike, Suite 650",
        "city": "Nashville",
        "state": "TN",
        "postalCode": "37207",
        "country": "United States",
        "phone": "(615) 868-4913"
      }
    ]
  },
  {
    "countryLabel": "",
    "stateLabel": "TX",
    "stateEntries": [
      {
        "name": "Allison Audiology and Hearing Aid Services, P.C.",
        "address": "12900 Queensbury Ln",
        "city": "Houston",
        "state": "TX",
        "postalCode": "77079",
        "country": "United States",
        "phone": "(713) 827-1767"
      },
      {
        "name": "Heights Audiology & Hearing",
        "address": "325 W 20th St # 1",
        "city": "Houston",
        "state": "TX",
        "postalCode": "77079",
        "country": "United States",
        "phone": "(713) 863-0114"
      },
      {
        "name": "Hearing Professional Center",
        "address": "5462 Glen Lakes Dr",
        "city": "Dallas",
        "state": "TX",
        "postalCode": "75231",
        "country": "United States",
        "phone": "(214) 987-4114"
      },
      {
        "name": "Total Hearing Care of Dallas",
        "address": "4130 Abrams Rd",
        "city": "Dallas",
        "state": "TX",
        "postalCode": "75214",
        "country": "United States",
        "phone": "(214) 827-1900"
      },
      {
        "name": "NewSound Hearing Aid Centers",
        "address": "910 N Main St",
        "city": "McAllen",
        "state": "TX",
        "postalCode": "75214",
        "country": "United States",
        "phone": "(956) 686-6881"
      },
      {
        "name": "Professional Hearing Aids",
        "address": "2101 S Cynthia St",
        "city": "McAllen",
        "state": "TX",
        "postalCode": "78503",
        "country": "United States",
        "phone": "(956) 618-2505"
      },
      {
        "name": "Audicles Hearing Services",
        "address": "901 NE Interstate 410 Loop",
        "city": "San Antonio",
        "state": "TX",
        "postalCode": "78209",
        "country": "United States",
        "phone": "(210) 820-0525"
      },
      {
        "name": "HearLab Audiology and Hearing Aids",
        "address": "5282 Medical Dr",
        "city": "San Antonio",
        "state": "TX",
        "postalCode": "78229",
        "country": "United States",
        "phone": "(210) 614-0100"
      },
      {
        "name": "RK Audiology",
        "address": "2003 S Lamar Blvd #4",
        "city": "Austin",
        "state": "TX",
        "postalCode": "78704",
        "country": "United States",
        "phone": "(512) 704-7447"
      },
      {
        "name": "Victory Hearing & Balance Center",
        "address": "3003 Bee Caves Rd #200",
        "city": "Austin",
        "state": "TX",
        "postalCode": "78746",
        "country": "United States",
        "phone": "(512) 443-3500"
      },
      {
        "name": "Pearland Hearing Aids & Audiology",
        "address": "2518 Westminister St.",
        "city": "Pearland",
        "state": "TX",
        "postalCode": "77581",
        "country": "United States",
        "phone": "(281) 317-4010"
      },
      {
        "name": "The Woodlands  Hearing Center",
        "address": "150 Pine Forest Dr. #104",
        "city": "The Woodlands",
        "state": "TX",
        "postalCode": "77384",
        "country": "United States",
        "phone": "(936) 271-3366 "
      }
    ]
  },
  {
    "countryLabel": "",
    "stateLabel": "UT",
    "stateEntries": [
      {
        "name": "Advanced Hearing Center",
        "address": "1137 E 2100 S",
        "city": "Salt Lake City",
        "state": "UT",
        "postalCode": "84106",
        "country": "United States",
        "phone": "(801) 386-8552"
      }
    ]
  },
  {
    "countryLabel": "",
    "stateLabel": "WA",
    "stateEntries": [
      {
        "name": "Northgate Hearing Service Inc.",
        "address": "10564 5th NE Ave Ste. 203",
        "city": "Seattle",
        "state": "WA",
        "postalCode": "98125",
        "country": "United States",
        "phone": "(206) 367-1345"
      }
    ]
  },
  {
    "countryLabel": "",
    "stateLabel": "WI",
    "stateEntries": [
      {
        "name": "Community Audiology Services",
        "address": "10243 W National Ave",
        "city": "Milwaukee",
        "state": "WI",
        "postalCode": "53227",
        "country": "United States",
        "phone": "(414) 541-4327"
      },
      {
        "name": "Kandula Madan N MD",
        "address": "1233 N Mayfair Rd #120",
        "city": "Milwaukee",
        "state": "WI",
        "postalCode": "53226",
        "country": "United States",
        "phone": "(414) 771-6780"
      },
      {
        "name": "Sherards Hearing Aid Center",
        "address": "4112 Laramie St",
        "city": "Cheyenne",
        "state": "WI",
        "postalCode": "82001",
        "country": "United States",
        "phone": "(307) 637-7415"
      }
    ]
  },
  {
    "countryLabel": "",
    "stateLabel": "WY",
    "stateEntries": [
      {
        "name": "Wyoming Hearing Clinic LLC",
        "address": "5320 Education Dr.",
        "city": "Cheyenne",
        "state": "WY",
        "postalCode": "82009",
        "country": "United States",
        "phone": "(307) 632-8224"
      }
    ]
  },
  {
    "countryLabel": "Venezuela",
    "stateLabel": "D.F.",
    "stateEntries": [
      {
        "name": "Avantec Medical",
        "address": "Centro Plaza Local MC 415",
        "city": "Caracas",
        "state": "D.F.",
        "postalCode": "1080",
        "country": "Venezuela",
        "phone": "(0212) 285-3297"
      }
    ]
  },
  {
    "countryLabel": "Panama",
    "stateLabel": "Panamá",
    "stateEntries": [
      {
        "name": "Lcda. Susan Cortés de Yangüez",
        "address": "Centro Especializado San Fernando, Piso 6, Local 6-14",
        "city": "Panamá",
        "state": "Panamá 0",
        "postalCode": "",
        "country": "Panamá",
        "phone": "3944693"
      }
    ]
  },
  {
    "countryLabel": "Mexico",
    "stateLabel": "D.F.",
    "stateEntries": [
      {
        "name": "Comaudi",
        "address": "Av. Patriotismo No.706 Col. Mixcoac",
        "city": "Ciudad de México",
        "state": "D.F.",
        "postalCode": "03910",
        "country": "Mexico",
        "phone": "01 800 080 6666"
      }
    ]
  },
  {
    "countryLabel": "Ireland",
    "stateLabel": "",
    "stateEntries": [
      {
        "name": "Healthcare Ireland Ltd.",
        "address": "60 Capel Street",
        "city": "Dublin",
        "state": "1",
        "postalCode": "",
        "country": "Ireland",
        "phone": "0035318726893"
      }
    ]
  },
  {
    "countryLabel": "Chile",
    "stateLabel": "Santiago",
    "stateEntries": [
      {
        "name": "Christian  Astete Vallejos",
        "address": "Dr. Manuel Barros Borgo\u00f1o 110,Oficina 1007, Providencia",
        "city": "Santiago",
        "state": "Santiago 0",
        "postalCode": "",
        "country": "Chile",
        "phone": "(562) 260 27912"
      },
      {
        "name": "Constanza Lazcano Barra",
        "address": "Universidad Andr\u00e9s Bello",
        "city": "Santiago",
        "state": "Santiago  0",
        "postalCode": "",
        "country": "Chile",
        "phone": "(569) 662 22464"
      }
    ]
  },
  {
    "countryLabel": "Republica Dominicana",
    "stateLabel": "Santiago",
    "stateEntries": [
      {
        "name": "Centro de Evaluacion Auditiva Frecuencia",
        "address": "AV. Rafael Vidal, Plaza Sunset Boulevard mod. K1",
        "city": "Jardines del Este",
        "state": "Santiago 0",
        "postalCode": "",
        "country": "Republica Dominicana",
        "phone": "809-583-1146"
      }
    ]
  }
];
var audJoin = '';
const audFinalList = [];

$.each(audList, function(n, data) {
  var country = '';
  const states = [];
  country = data.countryLabel
  if(country !== '') {
    country = '<h3 class="aud_country">' + data.countryLabel + '</h3>';
  }
  var countryState = country + '<h4 class="aud_state tm-ffdin">' + data.stateLabel + '</h4>';
  $.each(data.stateEntries, function(ndx, item) {
    states.push('<div class="tm-audiologist-section-card aud_info"><h5 class="tm-ffdin tm-caps">' + item.name + '</h5><p>' + 
                item.address + '</p><p>' + item.city + ', ' + item.state + ' ' + item.postalCode + '</p><p>' + item.country + '</p><p><a href="tel:' + 
                item.phone + '">' + item.phone + '</a></p></div>')
  })
  var htmlStates = '<div class="tm-audiologist-section-grid">' + states.join('') + '</div></div>';  

  audFinalList.push(countryState + htmlStates);
});
  audJoin = audFinalList.join('');
  $('#audiologist-list').html(audJoin);

  
  $('.search').on('keyup', function() {
      var searchText = $(this).val().toLowerCase(); // Get the input value and convert it to lowercase
      var $parentDiv = $("#audiologist-list"); // Replace with the div ID
      var $resultDiv = $("#audiologist-results"); // Result Div
      const resultArr = [];

      if(searchText.length > 0) {
        $parentDiv.hide();
        $resultDiv.show();
        $('.aud_state').hide();
      } else {
        $parentDiv.show();
        $('.aud_state').show();
        $resultDiv.hide();  
      }
    
      $parentDiv.children().children().each(function() {
          if ($(this).text().toLowerCase().indexOf(searchText) > -1) {
              resultArr.push($(this)[0].outerHTML)
          }
      });
    $resultDiv.html('<div class="tm-audiologist-section-grid">' + resultArr.join('') + '</div></div>')
  });
})


(()=>{
  var navbar = document.getElementById("audiologist-search-bar");
  var sticky = navbar.offsetTop - 72;
  const stickyMenu = ()=> {
    if (window.pageYOffset >= sticky) {
      navbar.classList.add("tm-sticky")
    } else {
      navbar.classList.remove("tm-sticky");
    }
  }
  window.onscroll = ()=>stickyMenu();
})();